import { defineMessages } from 'react-intl';

export const heidi2RequestAccessModalMessages = defineMessages({
  tagline: {
    defaultMessage: 'Heidi writes, answers, and <i>now acts</i>.',
    id: 'Px6+cniqqy',
    description:
      'Tagline in the hero of the Heidi II request-access modal. i wraps the italic phrase “now acts”.',
  },
  title: {
    defaultMessage: 'Ask your admin for Heidi II',
    id: 'ZPi2hrtQwG',
    description: 'Title of the modal where a non-admin asks their admin for Heidi II',
  },
  description: {
    defaultMessage:
      'Off your desk, onto Heidi’s. Your admin can give you access to Heidi agents.',
    id: 'AXYt6ka44i',
    description: 'Body copy of the Heidi II request-access modal',
  },
  whatIsHeidi2: {
    defaultMessage: 'See what Heidi II does.',
    id: 'lAxy1QqA62',
    description: 'Link to the Heidi II announcement from the request-access modal',
  },
  messageLabel: {
    defaultMessage: 'Note to admin (optional)',
    id: 'kzf7zI3McH',
    description:
      'Label of the optional message to admins in the Heidi II request-access modal',
  },
  messagePlaceholder: {
    defaultMessage: 'E.g. I’d like Heidi to take referrals and follow-ups off my desk.',
    id: 'EQgUJVYLuP',
    description:
      'Placeholder of the optional message in the Heidi II request-access modal',
  },
  messageTooLong: {
    defaultMessage: 'Keep your message under {max, number} characters',
    id: 'xlFKFD1nEi',
    description: 'Validation error when the Heidi II access request message is too long',
  },
  cancel: {
    defaultMessage: 'Cancel',
    id: '1nrpaYre/q',
    description: 'Button closing the Heidi II request-access modal without sending',
  },
  send: {
    defaultMessage: 'Send',
    id: 'S835KSZDat',
    description: 'Button sending the Heidi II access request to workspace admins',
  },
  requestSent: {
    defaultMessage: 'Request sent to your admin',
    id: 'MHXu+Yj5N2',
    description:
      'Toast shown after a Heidi II access request is sent to workspace admins',
  },
  alreadyRequested: {
    defaultMessage: 'You’ve already sent a request',
    id: 'wQgqt0iGRj',
    description: 'Toast shown when a Heidi II access request was already sent earlier',
  },
  requestError: {
    defaultMessage: 'Couldn’t send request. Try again.',
    id: 'U1nEKudJkU',
    description: 'Toast shown when sending a Heidi II access request fails',
  },
});
